import { RegistrationProjectsSource } from './types';

export const LS_KEY_IS_TTN_MOBILE_APP = 'IS_TTN_MOBILE_APP';

export const VALID_PROJECT_SOURCES: RegistrationProjectsSource[] = [
    'edi',
    'kasa',
    'kep',
    'ttn',
];
